module.exports = __webpack_public_path__ + "img/all-cards.e528060b.svg";